import { useMutation } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface DownloadPdfRequestParams {
	company_id: string;
	organization_id: string;
	file_id: string;
	custom_report_result_id: string;
	locale: string;
	report_id: string;
	exclude_fields: string[];
}

const Service = Resolution886ReportService.getInstance();

export const useDownloadResolution886PDF = () => {
	return useMutation({
		mutationFn: async (params: DownloadPdfRequestParams) => Service.downloadPdf(params),
		onSuccess: (url) => {
			window.open(url);
			message.success(I18n.get('Document created successfully'));
		},
		onError: (err: any) => {
			message.error(I18n.get(err.response.data.message));
		}
	});
};
